import React from 'react'

type Props = {
  size?: number;
};

export const MethodIcon: React.FC<Props> = ({ size = 30 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_174_918)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1858 0C21.9255 0 22.5251 0.599618 22.5251 1.33929V3.09769C22.5251 3.83736 21.9255 4.43698 21.1858 4.43698C20.4462 4.43698 19.8465 3.83736 19.8465 3.09769V1.33929C19.8465 0.599618 20.4462 0 21.1858 0ZM8.67367 18.7246C11.5478 18.7246 13.8777 16.3947 13.8777 13.5205C13.8777 10.6464 11.5478 8.31645 8.67367 8.31645C5.79954 8.31645 3.46959 10.6464 3.46959 13.5205C3.46959 16.3947 5.79954 18.7246 8.67367 18.7246ZM0 29.1326C0 24.3424 3.88324 20.4592 8.67345 20.4592C13.4637 20.4592 17.3469 24.3424 17.3469 29.1326C17.3469 29.6117 16.9586 30 16.4795 30H0.867345C0.388324 30 0 29.6117 0 29.1326ZM29.3925 5.34159C29.9979 4.91661 30.1442 4.08133 29.7193 3.47593C29.2941 2.87055 28.4589 2.7243 27.8535 3.14927L26.4144 4.15956C25.809 4.58456 25.6626 5.41984 26.0876 6.02522C26.5127 6.63062 27.348 6.77687 27.9534 6.3519L29.3925 5.34159ZM12.6483 3.47593C12.2233 4.08133 12.3696 4.91661 12.9749 5.34159L14.4141 6.3519C15.0195 6.77687 15.8548 6.63062 16.2798 6.02522C16.7048 5.41984 16.5585 4.58456 15.9531 4.15956L14.5139 3.14927C13.9085 2.7243 13.0733 2.87055 12.6483 3.47593ZM21.0868 6.08608C23.7294 6.0312 25.9663 8.23046 25.9564 10.8735C25.9348 12.6282 24.8831 14.3034 23.3121 15.0853V17.4706C23.3087 17.6093 23.2511 17.741 23.1516 17.8378C23.0524 17.9345 22.9191 17.9886 22.7805 17.9886H19.5911C19.4524 17.9886 19.3192 17.9345 19.2199 17.8378C19.1206 17.741 19.0631 17.6093 19.0595 17.4706V15.1262C17.5365 14.3679 16.4971 12.7712 16.4201 11.0716C16.3005 8.43122 18.4443 6.14096 21.0868 6.08608Z"
          fill="#C08497"
        />
      </g>
      <defs>
        <clipPath id="clip0_174_918">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
